import React, { useEffect, useState } from 'react';
import { heroContent, assets } from '../utils/mock';

export const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, [setIsVisible]);

  // Split quote once to avoid recreating array on each render
  const quoteParts = React.useMemo(() => heroContent.quote.split("DON'T"), []);

  return (
    <section className="hero-section relative min-h-[65vh] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={assets.heroBackground}
          alt="Financial Background"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-[#29367A]/95 via-[#29367A]/90 to-[#29367A]/85"></div>
      </div>

      {/* Content - Centered Vertically */}
      <div className="absolute inset-0 z-10 flex items-center justify-center" style={{ paddingTop: '80px' }}>
        <div className="w-full max-w-7xl mx-auto px-8 text-center">
          <div
            className={`w-full transition-all duration-1000 transform ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`
            }>

          <h1
              className="hero-quote !font-normal !text-2xl !leading-[2.5rem] !text-center !italic md:!text-4xl lg:!text-5xl md:!leading-[3.5rem] lg:!leading-[4rem] !pt-[60px] !pb-[60px] !px-6 md:!px-20 lg:!px-[80px] text-white"
              style={{
                fontFamily: "Arial, sans-serif",
                letterSpacing: '0.02em',
                lineHeight: '3.0'
              }}>

            &ldquo;
            {quoteParts.map((part, idx) =>
              <React.Fragment key={`quote-part-${idx}`}>
                {part}
                {idx === 0 &&
                <span className="font-bold text-[#FFD700]">DON&apos;T</span>
                }
              </React.Fragment>
              )}
            &rdquo;
          </h1>
        </div>
      </div>
    </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-white/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-white/5 rounded-full blur-3xl"></div>
    </section>);

};